<script>
import Notification from "@/components/reUse/Notification.vue";

export default {
  name: "Changes",
  components: {Notification},
  data() {
    return {
      spremembe: null,
      types: '',
      ShowNoti: false,
      vnasam: false
    }
  },
  mounted() {
    this.BeriSpremembe();
  },
  methods: {
    BeriSpremembe() {
      axios.get('./api/changelog/v2/izpis/', {withCredentials: true}).then((response) => {
        this.spremembe = response.data.podatki;
      }).catch((error) => {
        this.types = "Napaka";
        this.text = error.data.response.napaka;
        this.ShowNoti = true;
      });
    }
  }
}
</script>

<template>
  <div class="pregled-povrsin-container">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas fa-arrow-left"></i>
            <span>Nazaj</span>
          </button>
        </div>

        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title">Vnos sprememb</h1>
          <!-- <p class="page-subtitle">Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov</p> -->
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid p-3">
    <Transition name="fade">
      <Notification v-if="ShowNoti" :message="text" :type="types" @closeNotification="ShowNoti = false" @da="confirmDelete" @ne="cancelDelete" />
    </Transition>
  </div>
  <main class="changelog">

    <header class="header">
      <h1 class="text-white">Changelog</h1>

      <p class="intro">
        Spremljajte najnovejše funkcionalnosti, izboljšave in popravke
        v naši aplikaciji.
      </p>
    </header>


    <section class="timeline">

      <!-- VERSION 2.4.0 -->

      <article class="release" v-for="sprememba in spremembe">

        <div class="release-dot"></div>

        <div class="release-meta">
          <span class="version">v{{ sprememba.verzija }}</span>
          <span class="date">{{ sprememba.datum }}</span>
        </div>

<!--        <h2>{{ sprememba.naslov }}</h2>-->

        <div class="changes">

          <div class="change" v-for="spremenjeno in sprememba.spremembe">
            <div class="change-top">
              <span class="badge" :class="{'new': spremenjeno.flag === 'novo', 'improved': spremenjeno.flag === 'izboljsano', 'fixed': spremenjeno.flag === 'popravljeno'}">{{ spremenjeno.flag }}</span>
              <h3 class="text-white">{{ spremenjeno.naslov }}</h3>
            </div>

            <p>
              {{ spremenjeno.opis }}
            </p>
          </div>
        </div>
      </article>

    </section>

  </main>
</template>

<style>
:root {
  --bg: #121a21;
  --surface: #26333f;
  --primary: #307acc;
  --primary-hover: #4088d6;
  --text: #f4f7fa;
  --text-muted: #9eacb8;
  --border: rgba(255, 255, 255, 0.08);

  --success: #35b87f;
  --warning: #e5a83b;
  --danger: #d85d68;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  background: var(--bg);
  color: var(--text);
  font-family:
      Inter,
      -apple-system,
      BlinkMacSystemFont,
      "Segoe UI",
      sans-serif;
}

.changelog {
  width: min(100% - 40px, 900px);
  margin: 0 auto;
  padding: 70px 0;
}

/* Header */

.header {
  margin-bottom: 60px;
}

.eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--primary);
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 14px;
}

.eyebrow::before {
  content: "";
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--primary);
  box-shadow: 0 0 12px rgba(48, 122, 204, .8);
}

h1 {
  margin: 0;
  font-size: clamp(36px, 6vw, 54px);
  line-height: 1.05;
  letter-spacing: -2px;
}

.intro {
  max-width: 620px;
  margin-top: 18px;
  color: var(--text-muted);
  font-size: 16px;
  line-height: 1.7;
}

/* Timeline */

.timeline {
  position: relative;
}

.timeline::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 4px;
  width: 1px;
  background: linear-gradient(
      to bottom,
      var(--primary),
      rgba(48, 122, 204, .1)
  );
}

.release {
  position: relative;
  padding-left: 48px;
  margin-bottom: 65px;
}

.release-dot {
  position: absolute;
  left: -3px;
  top: 4px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: var(--primary);
  border: 4px solid var(--bg);
  box-shadow: 0 0 0 1px var(--primary),
  0 0 18px rgba(48, 122, 204, .45);
}

.release-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}

.version {
  color: var(--primary);
  font-weight: 700;
  font-size: 14px;
}

.date {
  color: var(--text-muted);
  font-size: 13px;
}

.release h2 {
  margin: 0 0 22px;
  font-size: 27px;
  letter-spacing: -.5px;
}

/* Change cards */

.changes {
  display: grid;
  gap: 12px;
}

.change {
  padding: 20px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 12px;

  transition:
      transform .2s ease,
      border-color .2s ease,
      box-shadow .2s ease;
}

.change:hover {
  transform: translateY(-2px);
  border-color: rgba(48, 122, 204, .45);
  box-shadow: 0 10px 30px rgba(0, 0, 0, .18);
}

.change-top {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.badge {
  display: inline-flex;
  padding: 5px 9px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .5px;
}

.badge.new {
  color: #77c9ff;
  background: rgba(48, 122, 204, .15);
}

.badge.improved {
  color: #69d7a5;
  background: rgba(53, 184, 127, .12);
}

.badge.fixed {
  color: #f0bd61;
  background: rgba(229, 168, 59, .12);
}

.change h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 650;
}

.change p {
  margin: 0;
  color: var(--text-muted);
  font-size: 14px;
  line-height: 1.65;
}

/* Mobile */

@media (max-width: 600px) {
  .changelog {
    width: min(100% - 28px, 900px);
    padding: 45px 0;
  }

  .header {
    margin-bottom: 45px;
  }

  .release {
    padding-left: 35px;
  }

  .release h2 {
    font-size: 23px;
  }

  .change {
    padding: 17px;
  }
}
</style>